import { render } from "./GobButton.vue?vue&type=template&id=63f13b02"
import script from "./GobButton.vue?vue&type=script&lang=js"
export * from "./GobButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__